import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Button,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import SideDrawer from "../Drawer";
import AddProductValMOdal from "../AddProductValMOdal";
import debounce from "lodash/debounce";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
import PlayBeepSound from "./PlayBeepSound";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "3%",
    minHeight: "280px",
    marginTop: "20px",
  },
  textFieldStyle: {
    width: "40%",
    height: "45px",
    "& .MuiInputBase-root": {
      height: "100%",
      boxSizing: "border-box",
    },
    "& input": {
      height: "100%",
      padding: "0 14px",
      boxSizing: "border-box",
    },
    "& .MuiSelect-select": {
      height: "100%",
      padding: "10px 14px",
      display: "flex",
      alignItems: "center",
    },
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100% !important",
    },
  },

  scanButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff !important",
    width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.only("sm")]: {
      width: "45%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  qrBoxContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "left",
  },
  scanner: {
    width: "40%",
    marginTop: "5%",
    position: "unset !important",
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

const ScanComponent = (props) => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [container, setContainer] = useState("");
  const [containerId, setContainerId] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [upc, setUpc] = useState("");
  const [locations, setLocations] = useState([]);
  const [scanDate, setScanDate] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [disableUpcField, setDisableUpcField] = useState(true);
  const [disableContainerField, setDisableContainerField] = useState(true);
  const [disableInvoiceField, setDisableInvoiceField] = useState(true);
  const [containerData, setContainerData] = useState([]);
  const [showContainerTable, setShowContainerTable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalCBM, setTotalCBM] = useState(null);
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });
  const [validationModal, setValidationModal] = useState(false);
  const upcInputRef = useRef(null);

  const [showScanner, setShowScanner] = useState(false);
  const [scanText, setScanText] = useState("");

  const html5QrcodeScannerRef = useRef(null);
  const qrcodeRegionId = "html5qr-code-full-region";

  const closeValidationModal = () => {
    setValidationModal(false);
  };

  const barcodeBtnClick = () => {
    if (selectedLocationId && upcInputRef.current) {
      upcInputRef.current.focus();
    }
  };
  useEffect(() => {
    if (showScanner) {
      const createConfig = () => ({
        fps: 10,
        qrbox: 250,
        disableFlip: false,
      });

      const config = createConfig();

      html5QrcodeScannerRef.current = new Html5QrcodeScanner(
        qrcodeRegionId,
        config
      );

      html5QrcodeScannerRef.current.render(
        (decodedText) => {
          // document.getElementById("result").innerText = decodedText;
          setScanText(decodedText);
        },
        (error) => {
          console.error("QR Code error: ", error);
        }
      );
    }

    return () => {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current
          .clear()
          .catch((error) =>
            console.error("Failed to clear html5QrcodeScanner: ", error)
          );
      }
    };
  }, [showScanner]);

  useEffect(() => {
    if (scanText) {
      handleScanUpc(scanText);
      const stopButton = document.getElementById(
        "html5-qrcode-button-camera-stop"
      );
      if (stopButton) {
        stopButton.click();
      } else {
        console.error("Stop button not found in the DOM.");
      }
    }
  }, [scanText]);

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //   }
  // };
  // const sessionUsername = Cookies.get("userName");
      const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);
  useEffect(() => {
      getAllLocationsData();
  }, []);

  useEffect(() => {
    if (
      (selectedLocationId && selectedLocationId !== "0" && container.trim()) ||
      invoiceNo.trim() ||
      scanDate.trim()
    ) {
      startScanning();
    }
  }, [selectedLocationId]);

  const getAllLocationsData = async () => {
    try {
      // if (!userData?.loginInfo?.data?.jwt) {
      //   setAlert({
      //     alertStatus: true,
      //     alertMessage: "User is not authenticated. Please log in again.",
      //     alertColor: "red",
      //   });
      //   return;
      // }
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getAllInwardLocations`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // if (!resp.ok) {
      //   setAlert({
      //     alertStatus: true,
      //     alertMessage: "Something went wrong please try after some time",
      //     alertColor: "red",
      //   });
      // }
      const resp = await api.get('getAllInwardLocations')
      const data = resp.data;

      if (data.result === "success" && Array.isArray(data.locations)) {
        setLocations(data.locations);
        setLoader(false);
      } else {
        setAlert({
          alertStatus: true,
          alertMessage: "Unble to fetch locations, please try again later",
          alertColor: "red",
        });
      }
    } catch (e) {
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
    }
  };

  const handleLocationChange = (event) => {
    setSelectedLocationId(event.target.value);
    setDisableContainerField(event.target.value == 0 ? true : false);
  };

  const getInvoiceNO = async () => {
    if (container.trim()) {
      setLoader(true);
      try {
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/getInvoiceNoByContainerId?containerId=${container}`,
        //   {
        //     method: "GET",
        //     headers: {
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //     },
        //   }
        // );
        const resp = await api.get(`/getInvoiceNoByContainerId?containerId=${container}`)
        const data =  resp.data;
        if (data.result === "success") {
          const inv = data.partNo;
          const invoiceNo = inv.split(",")[0];
          const containerId = inv.split(",")[1];
          const archFlag = inv.split(",")[2];

          setInvoiceNo(invoiceNo);
          setContainerId(containerId);
          setDisableInvoiceField(false);
        } else if (data.result === "error") {
          setDisableInvoiceField(false);
          setInvoiceNo("");
        }
      } catch (e) {
        setAlert({
          alertStatus: true,
          alertMessage: "Error retrieving data",
          alertColor: "red",
        });
      } finally {
        setLoader(false);
      }
    }
  };

  const startScanning = async () => {
    if (!container.trim() || !invoiceNo.trim() || !scanDate.trim()) {
      setAlert({
        alertStatus: true,
        alertMessage: "Please enter container, Invoice No and Scan Date",
        alertColor: "red",
      });
    } else {
      setLoader(true);
      try {
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/getByContainerId?containerId=${container}&shipToLocId=${selectedLocationId}`,
        //   {
        //     method: "GET",
        //     headers: {
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //     },
        //   }
        // );
        const resp = await api.get(`/getByContainerId?containerId=${container}&shipToLocId=${selectedLocationId}&contId=${containerId ? containerId : 0 }`)
        const data = resp.data;
        if (data.resultData) {
          setShowContainerTable(true);
          setTotalCBM(data.totalCBM);
        }
        setContainerData(data.resultData);
        setDisableContainerField(true);
        setDisableInvoiceField(true);
        setDisableUpcField(false);
        setTimeout(() => {
          upcInputRef.current?.focus();
        }, 0);
      } catch (e) {
        console.log("getByContainerId Error:", e);
        setAlert({
          alertStatus: true,
          alertMessage: "Error retrieving data",
          alertColor: "red",
        });
      } finally {
        setLoader(false);
      }
    }
  };

  const stopScanning = () => {
    setDisableContainerField(true);
    setDisableInvoiceField(true);
    setDisableUpcField(true);
    setContainer("");
    setUpc("");
    setShowContainerTable(false);
    setContainerData([]);
    setTotalCBM(null);
    setShowScanner(false);
    setScanText("");
    setInvoiceNo("");
    setScanDate("");
    setSelectedLocationId("");
    const stopButton = document.getElementById(
      "html5-qrcode-button-camera-stop"
    );
    if (stopButton) {
      stopButton.click();
    } else {
      console.error("Stop button not found in the DOM.");
    }
    setShowScanner(false);
  };

  const headCells = [
    { id: "partNumber", label: "Part Number" },
    { id: "scanCount", label: "Scan Count" },
  ];

  const handleUpcChange = (e) => {
    const newUPC = e.target.value;
    setUpc(newUPC);
  };
  const handleContainerChange = (e) => {
    const newCont = e.target.value;
    setContainer(newCont);
  };
  useEffect(() => {
    const debounceHandler = setTimeout(() => {
      if (upc.trim()) {
        handleScanUpc(upc.trim());
      }
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(debounceHandler);
    };
  }, [upc]);
  useEffect(() => {
    const debounceHandler = setTimeout(() => {
      if (container) {
        getInvoiceNO(container);
      }
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(debounceHandler);
    };
  }, [container]);
  const handleScanUpc = async (newUPC) => {
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getPartNoAndSaveContainerData`,
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       upc: newUPC.trim(),
      //       containerId: container.trim(),
      //       invoiceNo: invoiceNo.trim(),
      //       emailId: userData.username,
      //       scanDate: scanDate.trim(),
      //       shipToLocId: selectedLocationId,
      //     }),
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post("/getPartNoAndSaveContainerData", {
               upc: newUPC.trim(),
            containerId: container.trim(),
            invoiceNo: invoiceNo.trim(),
            emailId: userData.username,
            scanDate: scanDate.trim(),
            shipToLocId: selectedLocationId,
            });
      const data = await resp.data;
      if (data.result === "success" && data.partNo) {
        if (containerData) {
          setContainerData((prevContainerData) => {
            const existingIndex = prevContainerData.findIndex(
              (item) => item.partNo.trim() === data.partNo.trim()
            );
            if (existingIndex !== -1) {
              const updatedContainerData = [...prevContainerData];
              updatedContainerData[existingIndex] = {
                ...updatedContainerData[existingIndex],
                scansCount: updatedContainerData[existingIndex].scansCount + 1,
              };
              return updatedContainerData;
            } else {
              return [
                ...prevContainerData,
                { partNo: data.partNo, scansCount: 1 },
              ];
            }
          });
        } else {
          setContainerData([{ partNo: data.partNo, scansCount: 1 }]);
        }

        setTotalCBM(data.totalCBM);
        setShowContainerTable(true);
      } else {
        setAlert({
          alertStatus: true,
          alertMessage: data.resultMessage || "Please enter a valid UPC or ensure the value is entered through scanning only.",
          alertColor: "red",
        });
        PlayBeepSound();
      }
      setUpc("");
      setScanText("");
    } catch (e) {
      console.log("getPartNoAndSaveContainerData Error :- ", e);
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
      PlayBeepSound();
    }
    if (container.trim() && !scanText.trim()) {
      setTimeout(() => {
        upcInputRef.current?.focus();
      }, 0);
    }
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="scan" userData={userData} />
      <main className={classes.content}>
        <Typography className={classes.title}>Outward Scan</Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            <Box
              display="flex"
              flexDirection="column"
              gridGap={20}
              alignItems="center"
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                {/* {totalCBM && ( */}
                <Box ml={5}>
                  <Typography>
                    Total CBM :- &nbsp;&nbsp; {totalCBM ? totalCBM : "0"}
                  </Typography>
                </Box>
                {/* )} */}
              </Box>
              <Box
                display="flex"
                flexWrap="wrap"
                gridGap={20}
                alignItems="center"
                width="100%"
              >
                <FormControl
                  className={classes.textFieldStyle}
                  sx={{
                    m: 0,
                    minWidth: 120,
                    width: "40%",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#cfd1cf",
                      },
                      "&:hover fieldset": {
                        borderColor: "#cfd1cf",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#cfd1cf",
                      },
                    },
                    "& label.Mui-focused": {
                      color: "black",
                    },
                  }}
                >
                  <InputLabel
                    id="demo-simple-select-required-label"
                    className={classes.textFieldStyle}
                  >
                    {" "}
                    Select Location{" "}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-required-label"
                    id="demo-simple-select-required"
                    value={selectedLocationId}
                    label="Select Location"
                    onChange={handleLocationChange}
                    sx={{ height: "45px" }}
                  >
                    {locations && locations.length > 0 ? (
                      locations.map((location) => (
                        <MenuItem key={location.id} value={location.id}>
                          {location.location}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value={0} disabled>
                        No Items
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
                <TextField
                  className={classes.textFieldStyle}
                  variant="outlined"
                  label="Scan Date"
                  type="date"
                  value={scanDate}
                  onChange={(e) => setScanDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    height: "45px",
                    "& .MuiFormControl-root": {
                      "& fieldset": {
                        height: "45px",
                      },
                    },
                  }}
                />
              </Box>
              <Box
                display="flex"
                flexWrap="wrap"
                gridGap={20}
                alignItems="center"
                width="100%"
              >
                <TextField
                  variant="outlined"
                  size="small"
                  className={classes.textFieldStyle}
                  placeholder="Enter Container"
                  value={container}
                  onChange={handleContainerChange}
                  // onBlur={getInvoiceNO}
                  // onChange={(e) => setContainer(e.target.value)}
                  disabled={disableContainerField}
                />
                <TextField
                  variant="outlined"
                  size="small"
                  className={classes.textFieldStyle}
                  placeholder="Enter Invoice No"
                  value={invoiceNo}
                  onChange={(e) => setInvoiceNo(e.target.value)}
                  disabled={disableInvoiceField}
                />
                <Button className={classes.scanButton} onClick={startScanning}>
                  Start Scan
                </Button>
              </Box>
            </Box>
            <Box
              display="flex"
              flexWrap="wrap"
              gridGap={20}
              alignItems="center"
              mt={3}
            >
              <TextField
                variant="outlined"
                size="small"
                className={classes.textFieldStyle}
                placeholder="Scan UPC"
                value={upc}
                onChange={handleUpcChange}
                // onBlur={handleUpcChange}
                inputRef={upcInputRef}
                disabled={disableUpcField}
              />
            </Box>

            <Box display="flex" justifyContent="left" mt={3}>
              <Typography
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  color: "red",
                  textTransform: "capitalize",
                }}
              >
                OR
              </Typography>
            </Box>

            <Box
              display="flex"
              flexWrap="wrap"
              gridGap={20}
              alignItems="center"
              mt={3}
            >
              <Button
                className={classes.scanButton}
                onClick={() => {
                  setShowScanner(true);
                  barcodeBtnClick();
                }}
                disabled={disableUpcField}
              >
                Scan Barcode
              </Button>
            </Box>

            {showScanner && (
              <Box>
                <Box className={classes.qrBoxContainer}>
                  <div id={qrcodeRegionId} className={classes.scanner} />
                </Box>
                {/* <Typography id="result" variant="body1" color="textSecondary" /> */}
                {/* <br /> */}
                <Typography>{scanText}</Typography>
              </Box>
            )}

            <Box mt={5}>
              <Button className={classes.scanButton} onClick={stopScanning}>
                Stop Scan
              </Button>
            </Box>
            <Box mt={4}>
              {showContainerTable && (
                <TableContainer>
                  <Table
                    style={{ borderRadius: "20px" }}
                    stickyHeader
                    aria-labelledby="tableTitle"
                  >
                    <TableHead>
                      <TableRow>
                        {headCells.map((headCell) => (
                          <TableCell
                            align="center"
                            style={{
                              backgroundColor: gpColors.logoGray,
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                            key={headCell.id}
                          >
                            {headCell.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loader ? (
                        <TableRow>
                          <TableCell colSpan={headCells.length} align="center">
                            <CircularProgress color="inherit" size={25} />
                          </TableCell>
                        </TableRow>
                      ) : containerData && containerData.length > 0 ? (
                        containerData.map((item, index) => (
                          <TableRow
                            key={item.id}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#fff" : "#fafafa",
                            }}
                          >
                            <TableCell
                              align="center"
                              style={{ fontSize: "0.875rem" }}
                            >
                              {item.partNo}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontSize: "0.875rem" }}
                            >
                              {item.scansCount}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={headCells.length}
                            align="center"
                            style={{ color: "red" }}
                          >
                            Data Not Exist
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          </CardContent>
        </Card>
      </main>
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};

export default ScanComponent;
